export const CustomerAccountManagementEndpoints = {
  SEARCH: '/api/admin/users',
  LOOKUP: '/api/admin/users/lookup',
  USER_TYPES: '/api/admin/users/user-types',
  UPDATE_USER_TYPE: '/api/admin/users/:id/user-type',
  RESET_PASSWORD: '/api/admin/users/:id/reset-password',
};
